function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CountUp } from 'countup.js';
import ViewportObserver from './ViewportObserver';
var StatBlockCounters = /*#__PURE__*/function () {
  function StatBlockCounters() {
    _classCallCheck(this, StatBlockCounters);
    this.selector = '[data-countup]';
    this.counters = Array.from(document.querySelectorAll(this.selector));
    if (!this.counters || this.counters.length === 0) return;
    this.setupCounters();
    this.setupObservers();
  }
  return _createClass(StatBlockCounters, [{
    key: "setupCounters",
    value: function setupCounters() {
      // ex: ($)(42.3)(B)
      var reg = /(^\D*?)(\d*\.?\,?\d*?)(\D*?$)/;
      // ex: (42)(.)(3)
      var decReg = /(\d+)(\.)(\d+)/;
      this.counters.forEach(function (counter) {
        var matched = counter.dataset.countup.replace(',', '').match(reg);
        var decimaled = matched[2].match(decReg);
        counter.countup = new CountUp(counter, matched[2], {
          decimalPlaces: decimaled ? decimaled[3].length : 0,
          startVal: 0,
          prefix: matched[1],
          suffix: matched[3]
        });
      });
    }
  }, {
    key: "setupObservers",
    value: function setupObservers(counter) {
      new ViewportObserver(this.counters, {
        className: 'in-threshold',
        threshold: '25%',
        onEnter: function onEnter(entry, observer) {
          return entry.target.countup.start();
        },
        onExit: function onExit(entry, observer) {
          return entry.target.countup.reset();
        },
        // onExit: (entry,observer) => entry.target.classList.add('exited'),
        handleOnce: false
      });
    }
  }]);
}();
export { StatBlockCounters as default };